import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { User } from 'models/user'
import { Card } from 'components/Card'
import { Flex } from 'components/Flex'
import { Stack } from 'components/Stack'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { Badge } from 'components/Badge'
import { useUpdateUser } from 'services/user'
import { UserFormFields, UserForm } from 'features/Organization/components/UserForm/UserForm'

export type BlockAction = 'block' | 'unblock'

type UserDetailsFormProps = {
  currentUser: User
  user: User
}

export const UserDetailsForm: FC<UserDetailsFormProps> = ({ currentUser, user }) => {
  const { t } = useTranslation()
  const [updateUser] = useUpdateUser(user.id)
  const [status, setStatus] = useState('idle')

  const handleUserSubmit = (data: UserFormFields) => {
    setStatus('loading')

    updateUser(data, {
      onSuccess: () => setStatus('success'),
      onError: () => setStatus('error'),
    })
  }

  return (
    <Card>
      <Stack space="large">
        <Stack space="xsmall">
          <Flex justify="between">
            <div>
              <Heading size="secondary">{t('user.edit.card.user.title')}</Heading>
              <Text>{t('user.edit.card.user.desc')}</Text>
            </div>
            {user.confirmed ? (
              user.blocked && <Badge>{t(`user.status.blocked`)}</Badge>
            ) : (
              <Badge tone="caution">{t(`user.status.pending`)}</Badge>
            )}
          </Flex>
        </Stack>
        <UserForm
          currentUser={currentUser}
          user={user}
          onSubmit={handleUserSubmit}
          status={status}
        />
      </Stack>
    </Card>
  )
}

UserDetailsForm.displayName = 'UserDetailsForm'
